import { Box, Button, Center, PinInput, Stack, Text } from "@mantine/core";
import { useState } from "react";
import { submitMfa } from "../../hooks/ovokApi";

interface MfaInputProps {
	loginId: string;
	onSuccess: (response: {
		sessionCode: string;
		profiles: Array<{
			tenantCode: string;
			project: {
				id: string;
				resourceType: string;
				name: string;
			};
			profile: {
				resourceType: string;
				id: string;
				meta: {
					project: string;
					versionId: string;
					lastUpdated: string;
					author: { reference: string };
					compartment: Array<{ reference: string }>;
				};
				name: Array<{ given: string[]; family: string }>;
				telecom: Array<{ system: string; use: string; value: string }>;
			};
		}>;
	}) => void;
	onError: (error: string) => void;
}

export function MfaInput({ loginId, onSuccess, onError }: MfaInputProps) {
	const [mfaCode, setMfaCode] = useState("");

	const handleSubmit = async () => {
		try {
			const response = await submitMfa(mfaCode, loginId);
			onSuccess(response);
		} catch (error) {
			onError(
				error instanceof Error ? error.message : "An unexpected error occurred"
			);
		}
	};

	return (
		<Center>
			<Stack align="center" gap="md">
				<Text size="lg" fw={500}>
					Enter MFA Code
				</Text>
				<PinInput
					length={6}
					value={mfaCode}
					onChange={setMfaCode}
					type="number"
					autoFocus
				/>
				<Button onClick={handleSubmit} disabled={mfaCode.length !== 6}>
					Verify
				</Button>
			</Stack>
		</Center>
	);
}
